'use strict';

var ajax = require('./ajax'),
    util = require('./util'),
    quickview = require('./quickview'),
    dialog = require('./dialog');

function initializeEvents() {
	  var $qvButton = $('.lookBookviewbutton');
	  $qvButton.off('click').on('click', function(e) {
		  var productTypeValue="";
    	  if($(this).closest(".product-tile").hasClass("product-set")) {
          	productTypeValue = "product-set";
          }else {
          	productTypeValue = "normal-product";
          }
            e.preventDefault();
            quickview.show({
                url: $(this).attr('href'),
                source: 'quickview',
                productType: productTypeValue 
            });
        });
}

exports.init = function () {
    initializeEvents();
    
};
